var map = {
	"./badge1.png": 69049,
	"./badge10.png": 5597,
	"./badge11.png": 68116,
	"./badge12.png": 3375,
	"./badge13.png": 64358,
	"./badge14.png": 57433,
	"./badge15.png": 60528,
	"./badge16.png": 30379,
	"./badge17.png": 92898,
	"./badge18.png": 39845,
	"./badge2.png": 55042,
	"./badge3.png": 18699,
	"./badge4.png": 26708,
	"./badge5.png": 47837,
	"./badge6.png": 80422,
	"./badge7.png": 49167,
	"./badge8.png": 47512,
	"./badge9.png": 20225
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8151;